<template>
  <div
    v-if="isActive || lazy === false"
    data-el="tab"
    :class="{ 'p-4': !noBody, hidden: !lazy && !isActive }"
  >
    <slot />
  </div>
</template>
<script setup lang="ts">
import { inject } from 'vue';
import type { TabItemProps, TabItemRef } from '~/lib/services/types';
import { computed, onMounted, ref } from '#imports';
import { PROVIDE_KEY_ADD_TAB } from '~/lib/services/helpers';

const { icon, lazy, title, selected, noBody, testId } = withDefaults(
  defineProps<
    TabItemProps & {
      lazy?: boolean;
      selected?: boolean;
      noBody?: boolean;
    }
  >(),
  {
    lazy: true,
    selected: false,
    noBody: false,
  },
);

const isActive = ref(false);

const href = computed(() => {
  return '#' + title?.toLowerCase().replace(/ /g, '-');
});

const addTab = inject<(tab: TabItemRef) => void>(PROVIDE_KEY_ADD_TAB);
onMounted(() => {
  isActive.value = selected;
  addTab?.({
    lazy,
    title,
    selected,
    noBody,
    testId,
    icon,
    href: href.value,
    isActive: () => isActive.value,
    setActive: (active: boolean) => (isActive.value = active),
  });
});
</script>
